import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "./LeavingCertificate.css";
import AdminHeader from "../common/AdminHeader";
import { baseUrl } from "../../Utility/constants";
import { getSchoolId } from "../../Utility/commonFunctions";
import { toast, ToastContainer } from "react-toastify";

const StudentRegistrationReport = () => {
  const [schoolId, setSchoolId] = useState("");
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState("");

  const [reportData, setReportData] = useState([]);
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [streams, setStreams] = useState([]);
  const [subjectGroups, setSubjectGroups] = useState([]);

  const [selectedStandardId, setSelectedStandardId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  const [selectedStreamId, setSelectedStreamId] = useState("");
  const [selectedSubjectGroupId, setSelectedSubjectGroupId] = useState("");
  const [standardValue, setStandardValue] = useState("");

  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  const sectionApiUrl = `${baseUrl}/api/SectionMaster/GetSectionByStandardID`;
  const streamApiUrl = `${baseUrl}/api/StreamMaster`;
  const subjectGroupApiUrl = `${baseUrl}/api/SubjectGroupMaster`;

  // =========================================================
  // API FIELD -> REPORT HEADER
  // =========================================================

  const headerNames = {
    // studentId: "Student ID",
    // studentOtherDetailsId: "Student Other Details ID",
    // schoolId: "School ID",

    firstName: "First Name",
    middleName: "Middle Name",
    lastName: "Last Name",

    //gender: "Gender ID",
    genderName: "Gender",

    studentContactNumber: "Student Contact Number",
    studentEmail: "Student Email",
    //password: "Password",

    dateOfBirth: "Date of Birth",
    dateOfBirthInWords: "Date of Birth (Words)",

    //religionId: "Religion ID",
    religionName: "Religion",

    //categoryId: "Category ID",
    categoryName: "Category",

    //casteId: "Caste ID",
    casteName: "Caste",

    //subCasteId: "Sub Caste ID",

    //bloodGroupId: "Blood Group ID",
    bloodGroupName: "Blood Group",

    heightInCm: "Height (CM)",
    weightInKg: "Weight (KG)",

    address: "Address",
    country: "Country",

    //stateId: "State ID",
    stateName: "State",

    //districtId: "District ID",
    districtName: "District",

    //talukaId: "Taluka ID",
    talukaName: "Taluka",

    //cityVillageId: "City/Village ID",
    cityVillageName: "City/Village",

    pincode: "Pincode",
    uidNo: "UID / Aadhaar Number",
    birthPlace: "Birth Place",

    //motherTongue: "Mother Tongue ID",
    motherTongueName: "Mother Tongue",

    disability: "Disability",
    disabilityType: "Disability Type",
    disabilityPercentage: "Disability Percentage",

    ews: "EWS",

    fatherFullName: "Father Full Name",

    parentContactNumber: "Parent Contact Number",
    parentEmail: "Parent Email",
    parentOccupation: "Parent Occupation",
    parentAadhaarNo: "Parent Aadhaar Number",
    parentHighestQualification: "Parent Highest Qualification",

    motherFullName: "Mother Full Name",
    motherContactNumber: "Mother Contact Number",
    motherEmail: "Mother Email",
    motherOccupation: "Mother Occupation",
    motherAadhaarNo: "Mother Aadhaar Number",
    motherHighestQualification: "Mother Highest Qualification",

    guardianFullName: "Guardian Full Name",
    guardianContactNumber: "Guardian Contact Number",
    guardianEmail: "Guardian Email",
    guardianOccupation: "Guardian Occupation",
    guardianAadhaarNo: "Guardian Aadhaar Number",
    guardianHighestQualification: "Guardian Highest Qualification",

    nameAsPerAadhaar: "Name As Per Aadhaar",

    sessionName: "Session",

    status: "Status",

    nationality: "Nationality",


    // Student Other Details

    previousSchoolName: "Previous School Name",
    //board: "Board ID",
    boardName: "Board Name",
    udiseNo: "UDISE No",
    studentSaralId: "Student Saral ID",
    permanentEducationNumber: "Permanent Education Number",

    photo: "Photo",
    sign: "Signature",
    uploadedDocument: "Uploaded Document",

    admissionDate: "Admission Date",

    generalRegisterNo: "General Register No",
    rollNo: "Roll No",

    //standardId: "Standard ID",
    standardName: "Standard",

    //streamId: "Stream ID",
    streamName: "Stream",

    //sectionId: "Section ID",
    sectionName: "Section",

    subjectGroupName: "Subject Group Name",

    //studentTypeId: "Student Type ID",
    sourceOfAdmission: "Source Of Admission",
    subjects: "Subjects",

    //apaARId: "APAAR ID",
    apaarId: "Apaar ID",

    previousStandard: "Previous Standard",
    previousStream: "Previous Stream",

    //studentGroupId: "Student Group ID",

    earlyRelease: "Early Release",
    earlyReleaseDate: "Early Release Date",
    earlyReleaseRemarksId: "Early Release Remarks ID",

    previousStandardPercentage: "Previous Standard Percentage",
    previousAttendancePercentage: "Previous Attendance Percentage",

    examSeatNo: "Exam Seat No",

    //grantTypeID: "Grant Type ID",
    grantTypeName: "Grant Type",

    //studentMediumId: "Student Medium ID",
    distanceOfStudentResidence: "Distance Of Student Residence",

    //createdBy: "Created By",
  };

  // =========================================================
  // COLUMN WIDTHS
  // =========================================================

  const columnWidths = {
    //studentId: "100px",
    // studentOtherDetailsId: "150px",
    // schoolId: "100px",

    firstName: "140px",
    middleName: "140px",
    lastName: "140px",

    //gender: "100px",
    genderName: "120px",

    studentContactNumber: "170px",
    studentEmail: "220px",
    //password: "150px",

    dateOfBirth: "130px",
    dateOfBirthInWords: "180px",

    //religionId: "110px",
    religionName: "140px",

    //categoryId: "110px",
    categoryName: "140px",

    //casteId: "100px",
    casteName: "140px",

    //subCasteId: "130px",

    //bloodGroupId: "130px",
    bloodGroupName: "130px",

    heightInCm: "110px",
    weightInKg: "110px",

    address: "300px",
    country: "120px",

    //stateId: "100px",
    stateName: "150px",

    //districtId: "110px",
    districtName: "150px",

    //talukaId: "100px",
    talukaName: "150px",

    //cityVillageId: "130px",
    cityVillageName: "180px",

    pincode: "100px",
    uidNo: "180px",
    birthPlace: "180px",

    //motherTongue: "140px",
    motherTongueName: "150px",

    disability: "110px",
    disabilityType: "150px",
    disabilityPercentage: "160px",

    ews: "80px",

    fatherFullName: "200px",

    parentContactNumber: "170px",
    parentEmail: "220px",
    parentOccupation: "180px",
    parentAadhaarNo: "180px",
    parentHighestQualification: "220px",

    motherFullName: "200px",
    motherContactNumber: "170px",
    motherEmail: "220px",
    motherOccupation: "180px",
    motherAadhaarNo: "180px",
    motherHighestQualification: "220px",

    guardianFullName: "200px",
    guardianContactNumber: "180px",
    guardianEmail: "220px",
    guardianOccupation: "180px",
    guardianAadhaarNo: "180px",
    guardianHighestQualification: "220px",

    nameAsPerAadhaar: "220px",

    //sessionId: "110px",
    sessionName: "130px",

    // createdOn: "160px",
    // updatedBy: "110px",
    // updatedOn: "160px",
    status: "120px",
    // isActive: "100px",
    // isInitialMessage: "140px",

    nationality: "120px",

    previousSchoolName: "250px",
    board: "100px",

    udisenO: "140px",
    studentSaralId: "150px",
    permanentEducationNumber: "200px",

    photo: "220px",
    sign: "220px",
    uploadedDocument: "250px",

    admissionDate: "140px",

    generalRegisterNo: "170px",
    rollNo: "110px",

    //standardId: "110px",
    standardName: "150px",

    //streamId: "100px",
    streamName: "150px",

    //sectionId: "100px",
    sectionName: "140px",

    //studentTypeId: "140px",
    sourceOfAdmission: "200px",
    subjects: "250px",

    //apaarId: "180px",
    apaARId: "180px",

    previousStandard: "160px",
    previousStream: "160px",

    //studentGroupId: "150px",

    earlyRelease: "130px",
    earlyReleaseDate: "160px",
    earlyReleaseRemarksId: "190px",

    previousStandardPercentage: "200px",
    previousAttendancePercentage: "210px",

    examSeatNo: "140px",

    //grantTypeID: "130px",
    grantTypeName: "150px",

    studentMediumId: "160px",

    distanceOfStudentResidence: "220px",

    //createdBy: "110px",
  };

  // =========================================================
  // LOAD USER DETAILS
  // =========================================================

  useEffect(() => {
    const loadUserDetails = async () => {
      const id = await getSchoolId();

      if (id) {
        setSchoolId(id);
      }

      setRole(localStorage.getItem("Role"));
      setUserId(localStorage.getItem("userID"));
    };

    loadUserDetails();
  }, []);

  // =========================================================
  // LOAD STANDARDS
  // =========================================================

  useEffect(() => {
    if (schoolId && role === "ADMIN") {
      axios
        .get(`${standardApiUrl}?id=${schoolId}`)
        .then((res) => setStandards(res.data))
        .catch(() => console.log("Error fetching standards"));
    }
  }, [schoolId, role]);

  // =========================================================
  // LOAD STREAMS
  // =========================================================

  useEffect(() => {
    if (role === "ADMIN") {
      axios
        .get(streamApiUrl)
        .then((res) => setStreams(res.data))
        .catch(() => console.log("Error fetching streams"));
    }
  }, [role]);

  // =========================================================
  // LOAD SUBJECT GROUPS
  // =========================================================

  useEffect(() => {
    if (role === "ADMIN") {
      axios
        .get(subjectGroupApiUrl)
        .then((res) =>
          setSubjectGroups(
            (res.data || []).filter(
              (subjectGroup) => Number(subjectGroup.isActive) === 1
            )
          )
        )
        .catch(() => console.log("Error fetching subject groups"));
    }
  }, [role, subjectGroupApiUrl]);

  // =========================================================
  // LOAD SECTIONS
  // =========================================================

  useEffect(() => {
    if (role === "ADMIN" && selectedStandardId) {
      axios
        .get(`${sectionApiUrl}?id=${selectedStandardId}`)
        .then((res) => setSections(res.data))
        .catch(() => console.log("Error fetching sections"));
    } else {
      setSections([]);
      setSelectedSectionId("");
    }
  }, [selectedStandardId, role]);

  // =========================================================
  // FETCH DATA
  // =========================================================

  const fetchData = async () => {
    try {
      let url = "";

      if (role === "ADMIN") {
        url =
          `${baseUrl}/api/PersonalDetails/StudentDetails` +
          `?AdminId=${userId}` +
          `&StandardId=${selectedStandardId || ""}` +
          `&SectionId=${selectedSectionId || ""}` +
          `&StreamId=${selectedStreamId || ""}` +
          `&SubjectGroupId=${selectedSubjectGroupId || ""}`;
      } else if (role === "TEACHER") {
        url =
          `${baseUrl}/api/PersonalDetails/StudentDetails` +
          `?TeacherId=${userId}`;
      } else {
        toast.warning("Invalid role.");
        return;
      }

      const response = await axios.get(url);

      setReportData(response.data || []);

      if (!response.data || response.data.length === 0) {
        toast.warning("No data available.");
      }
    } catch (error) {
      console.error("Failed to fetch report data", error);
      toast.error("Failed to fetch report data.");
    }
  };

  // =========================================================
  // AUTO FETCH FOR TEACHER
  // =========================================================

  useEffect(() => {
    if (role === "TEACHER" && userId) {
      fetchData();
    }
  }, [role, userId]);

  // =========================================================
  // STANDARD CHANGE
  // =========================================================

  const handleChange = (e) => {
    setSelectedStandardId(e.target.value);

    setStandardValue(
      e.target.options[e.target.selectedIndex].text
    );

    setSelectedSectionId("");
    setSelectedStreamId("");
  };

  // =========================================================
  // DISPLAY VALUE
  // =========================================================

  const getDisplayValue = (value, key = "") => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "";
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    // Format dates
    if (
      key.toLowerCase().includes("date") ||
      key === "createdOn" ||
      key === "updatedOn"
    ) {
      if (!isNaN(Date.parse(value))) {
        return new Date(value).toLocaleDateString("en-IN");
      }
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    return value;
  };

  // =========================================================
  // API KEYS
  // =========================================================

  const allApiKeys =
    reportData.length > 0
      ? Object.keys(reportData[0])
      : [];

  // =========================================================
  // EXPORT DATA
  // =========================================================

  const exportRows = reportData.map((student) => {
    const exportRow = {};

    allApiKeys.forEach((key) => {
      const header = headerNames[key] || key;

      exportRow[header] = getDisplayValue(
        student[key],
        key
      );
    });

    return exportRow;
  });

  // =========================================================
  // EXPORT EXCEL
  // =========================================================

  const exportToExcel = () => {
    if (reportData.length === 0) {
      toast.warning("No data available to export.");
      return;
    }

    const worksheet =
      XLSX.utils.json_to_sheet(exportRows);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Student Details"
    );

    XLSX.writeFile(
      workbook,
      "Student_Details_Report.xlsx"
    );
  };

  // =========================================================
  // UI
  // =========================================================

  return (
    <>
      <AdminHeader />

      <ToastContainer />

      <div className="mt-5 mb-5 ms-5 me-5">

        <div className="d-flex align-items-center justify-content-center gap-3 mb-4 flex-nowrap">

          {/* HEADING */}
          <h2 className="mb-0 me-3 text-nowrap">
            Student Registration Report
          </h2>

          {role === "ADMIN" && (
            <>
              {/* STANDARD */}
              <select
                className="form-control"
                value={selectedStandardId}
                onChange={handleChange}
                style={{
                  width: "150px",
                  minWidth: "150px"
                }}
              >
                <option value="">
                  Select Standard
                </option>

                {standards.map((std) => (
                  <option
                    key={std.id}
                    value={std.id}
                  >
                    {std.standardName}
                  </option>
                ))}
              </select>

              {/* SECTION */}
              <select
                className="form-control"
                value={selectedSectionId}
                onChange={(e) =>
                  setSelectedSectionId(e.target.value)
                }
                disabled={!sections.length}
                style={{
                  width: "150px",
                  minWidth: "150px"
                }}
              >
                <option value="">
                  Select Section
                </option>

                {sections.map((sec) => (
                  <option
                    key={sec.id}
                    value={sec.id}
                  >
                    {sec.name}
                  </option>
                ))}
              </select>

              {/* STREAM */}
              <select
                className="form-control"
                value={selectedStreamId}
                onChange={(e) =>
                  setSelectedStreamId(e.target.value)
                }
                disabled={
                  standardValue &&
                  Number(standardValue) <= 10
                }
                style={{
                  width: "150px",
                  minWidth: "150px"
                }}
              >
                <option value="">
                  Select Stream
                </option>

                {streams.map((stream) => (
                  <option
                    key={stream.id}
                    value={stream.id}
                  >
                    {stream.name}
                  </option>
                ))}
              </select>

              {/* SUBJECT GROUP */}
              <select
                className="form-control"
                value={selectedSubjectGroupId}
                onChange={(e) =>
                  setSelectedSubjectGroupId(e.target.value)
                }
                style={{
                  width: "180px",
                  minWidth: "180px"
                }}
              >
                <option value="">
                  Select Subject Group
                </option>

                {subjectGroups.map((subjectGroup) => (
                  <option
                    key={subjectGroup.subjectGroupId}
                    value={subjectGroup.subjectGroupId}
                  >
                    {subjectGroup.subjectGroupName}
                  </option>
                ))}
              </select>

              {/* SEARCH */}
              <button
                className="btn btn-primary text-nowrap"
                onClick={fetchData}
              >
                Search
              </button>
            </>
          )}

          {/* EXPORT */}
          {reportData.length > 0 && (
            <button
              className="btn btn-success text-nowrap"
              onClick={exportToExcel}
            >
              Export Excel
            </button>
          )}

        </div>

        {/* =================================================
            TABLE
        ================================================= */}

        {reportData.length > 0 && (

          <div
            className="table-responsive"
            style={{
              width: "100%",
              maxWidth: "100%",
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "70vh",
              border: "1px solid #dee2e6"
            }}
          >

            <table
              className="table table-bordered table-striped table-hover mb-0"
              style={{
                minWidth: "3500px",
                width: "max-content",
                tableLayout: "fixed"
              }}
            >

              {/* ================================
                  HEADER
              ================================= */}

              <thead className="table-dark">

                <tr>

                  {allApiKeys.map((key) => (

                    <th
                      key={key}
                      style={{
                        width:
                          columnWidths[key] ||
                          "150px",

                        minWidth:
                          columnWidths[key] ||
                          "150px",

                        maxWidth:
                          columnWidths[key] ||
                          "150px",

                        whiteSpace: "normal",
                        overflowWrap: "break-word",
                        wordBreak: "break-word",

                        lineHeight: "1.2",
                        verticalAlign: "middle",
                        textAlign: "center",

                        padding: "10px 8px",

                        position: "sticky",
                        top: 0,
                        zIndex: 2
                      }}
                    >

                      {headerNames[key] || key}

                    </th>

                  ))}

                </tr>

              </thead>

              {/* ================================
                  BODY
              ================================= */}

              <tbody>

                {reportData.map(
                  (student, index) => (

                    <tr key={index}>

                      {allApiKeys.map((key) => (

                        <td
                          key={`${index}-${key}`}
                          style={{
                            width:
                              columnWidths[key] ||
                              "150px",

                            minWidth:
                              columnWidths[key] ||
                              "150px",

                            maxWidth:
                              columnWidths[key] ||
                              "150px",

                            whiteSpace: "normal",

                            overflowWrap:
                              "break-word",

                            wordBreak:
                              "break-word",

                            lineHeight: "1.4",

                            verticalAlign:
                              "top",

                            padding:
                              "8px"
                          }}
                        >

                          {getDisplayValue(
                            student[key],
                            key
                          )}

                        </td>

                      ))}

                    </tr>

                  )
                )}

              </tbody>

            </table>

          </div>

        )}

      </div>
    </>
  );
};

export default StudentRegistrationReport;